import { ErrorBoundary } from '@monorepo/shared/componentsV2/ErrorBoundary';
import { RoutesWith404 } from '@monorepo/shared/componentsV2/RoutesWith404';
import { useIsSuperAdmin } from '@monorepo/shared/hooks/permissions/useIsSuperAdmin';
import { useFeatureFlags } from 'mapistry-shared/api';
import * as React from 'react';
import { Navigate, Route } from 'react-router-dom';
import { AddResourcesPage } from './components/EditResourceType/AddResourcesPage/AddResourcesPage';
import { EditResourcePropertiesPage } from './components/EditResourceType/EditResourcePropertiesPage/EditResourcePropertiesPage';
import { EditResourceTypePage } from './components/EditResourceType/EditResourceTypePage/EditResourceTypePage';
import { ResourceTypeAnalyticsSyncPage } from './components/EditResourceType/ResourceTypeAnalyticsSyncPage';
import { ResourceDetails } from './components/ResourceDetails';
import { ResourceTypeDetailsPage } from './components/ResourceTypeDetailsPage/ResourceTypeDetailsPage';
import { ViewResources } from './components/ViewResources';
import { ViewResourceTypes } from './components/ViewResourceTypes';
import { ResourceTypeEditMode } from './types/routerTypes';

export function ResourceDataSetupRouter() {
  const { isData2Enabled } = useFeatureFlags();
  const isSuperAdmin = useIsSuperAdmin();

  return isData2Enabled ? (
    <RoutesWith404>
      <Route index element={<ViewResourceTypes />} />
      <Route
        path={ResourceTypeEditMode.NEW}
        element={<EditResourceTypePage />}
      />
      <Route path=":resourceTypeId">
        <Route index element={<ResourceTypeDetailsPage />} />
        <Route path="resources">
          <Route index element={<Navigate replace to="pages" />} />
          <Route path="pages">
            <Route index element={<Navigate replace to="0" />} />
            <Route path=":pageNumber">
              <Route index element={<ViewResources />} />
            </Route>
          </Route>
          <Route path=":resourceId" element={<ResourceDetails />} />
        </Route>
        <Route path=":mode">
          <Route index element={<Navigate replace to="basic-info" />} />
          <Route path="basic-info">
            <Route index element={<EditResourceTypePage />} />
          </Route>
          <Route path="properties">
            <Route index element={<EditResourcePropertiesPage />} />
          </Route>
          <Route path="add-resources">
            <Route index element={<AddResourcesPage />} />
          </Route>
          {isSuperAdmin && (
            <Route path="analytics">
              <Route
                index
                element={
                  <ErrorBoundary>
                    <ResourceTypeAnalyticsSyncPage />
                  </ErrorBoundary>
                }
              />
            </Route>
          )}
        </Route>
      </Route>
    </RoutesWith404>
  ) : null;
}
